
<template>
  <div class="my-pagination">
    <!-- 显示第x条，共几条 -->
    <div class="pagination-total">
      第{{
        pageNo === 1
          ? totalCount === 0
            ? 0
            : pageNo
          : (pageNo - 1) * pageSize
      }}-{{
        pageNo * pageSize > totalCount ? totalCount : pageNo * pageSize
      }}条，共{{ totalCount }}条
    </div>
    <!-- 选择每页显示几条 -->
    <div class="pagination-sizes">
      <select :value="pageSize" @change="changeSizes($event)">
        <option
          v-for="item in sizes"
          :key="item"
          :value="item"
        >
          每页显示{{ item }}条
        </option>
      </select>
      <div>
        <span></span>
      </div>
    </div>
    <!-- 跳页导航 -->
    <div class="pagination-navbar">
      <div
        class="first-page navbar-item"
        :class="pageNo <= 1 ? 'disabled' : ''"
        @click="firstPage()"
      >
        首页
      </div>
      <div
        class="prev-page navbar-item"
        :class="pageNo === 1 ? 'disabled' : ''"
        @click="prev()"
      >
        上一页
      </div>
      <ul class="num-page navbar-item">
        <li
          v-if="page > 5"
          @click="prevFivePage()"
        >...</li>
        <li
          v-for="item in pageArr"
          :key="item"
          :class="item === pageNo ? 'active' : ''"
          @click="active(item)"
        >
          {{ item }}
        </li>
        <li
          v-if="totalPage > page"
          @click="nextFivePage()"
        >...</li>
      </ul>
      <div
        class="next-page navbar-item"
        :class="pageNo === totalPage || totalCount === 0 ? 'disabled' : ''"
        @click="next()"
      >
        下一页
      </div>
      <div
        class="last-page navbar-item"
        :class="pageNo === totalPage || totalCount === 0 ? 'disabled' : ''"
        @click="lastPage()"
      >
        尾页
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "my-pagination",
  data() {
    return {
      page: 5, //最大页
      pageArr: [],
      totalPage: 0, //总页数
    };
  },
  props: {
    pageNo: Number,
    pageSize: Number,
    totalCount: Number,
    sizes: Array,
  },
  computed: {},
  methods: {
    //初始化分页
    initPage() {
      if (this.totalPage > 5) {
        this.page = 5;
      } else {
        this.page = this.totalPage;
      }
      for (let i = 1; i <= this.page; i++) {
        this.pageArr.push(i);
      }
    },
    //首页
    firstPage() {
      this.pageArr = [];
      this.$emit("change", 1);
      if (this.totalPage < 5) {
        this.page = this.totalPage;
      } else {
        this.page = 5;
      }
      for (let i = 1; i <= this.page; i++) {
        this.pageArr.push(i);
      }
    },
    //尾页
    lastPage() {
      this.$emit("change", this.totalPage);
      this.pageArr = [];
      this.page = this.totalPage;
      for (
        let i = this.totalPage - (this.totalPage % 5) + 1;
        i <= this.page;
        i++
      ) {
        this.pageArr.push(i);
      }
    },
    //上一页
    prev() {
      this.$emit("change", this.pageNo - 1);
      if ((this.pageNo - 1) % 5 == 0) {
        this.prevFivePage(true);
      }
    },
    //下一页
    next() {
      this.$emit("change", this.pageNo + 1);
      if (this.pageNo % 5 == 0) {
        this.nextFivePage(true);
      }
    },
    //上5页或者上一页
    prevFivePage(prev) {
      this.page -= 5;
      if (this.page > 5) {
        this.page += (this.totalPage % 5) + 1;
      } else {
        this.page = 5;
      }
      if (prev) {
        this.$emit("change", this.pageNo - 1);
      } else {
        this.$emit("change", this.page - 4);
      }
      this.pageArr = [
        this.page - 4,
        this.page - 3,
        this.page - 2,
        this.page - 1,
        this.page,
      ];
    },
    //下5页或者下一页
    nextFivePage(next) {
      this.page += 5;
      if (this.totalPage < this.page) {
        this.page = this.totalPage;
        this.$emit("change", this.page - (this.totalPage % 5) + 1);
        this.pageArr = [];
        for (
          let i = this.totalPage - (this.totalPage % 5) + 1;
          i <= this.page;
          i++
        ) {
          this.pageArr.push(i);
        }
      } else {
        if (next) {
          this.$emit("change", this.pageNo + 1);
        } else {
          this.$emit("change", this.pageNo + 5);
        }
        this.pageArr = [
          this.page - 4,
          this.page - 3,
          this.page - 2,
          this.page - 1,
          this.page,
        ];
      }
    },
    //改变一页多少条
    changeSizes(pageSize) {
      console.log("changeSizes", pageSize);
      this.$emit("changeSizes", Number(pageSize.target.value));
    },
    active(pageNo) {
      console.log("active", pageNo);
      this.$emit("change", pageNo);
    },
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
  },
  mounted() {
    // 模板编译/挂载之后
  },
  created() {},
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
    // Tips：你确认删除XX吗？
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
  // 数据监听
  watch: {
    pageSize: {
      handler: function (newValue, oldValue) {
        this.totalPage = Math.ceil(this.totalCount / this.pageSize);
        this.pageArr = [];
        this.initPage();
      },
      immediate: true,
    },
    totalCount: {
      handler: function (newValue, oldValue) {
        this.totalPage = Math.ceil(this.totalCount / this.pageSize);
        this.pageArr = [];
        this.initPage();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less">
.my-pagination {
  display: flex;
  width: auto;
  height: 36px;
  font-size: 12px;
  font-family: SimSun;
  font-weight: 400;
  color: #a1a1a1;
  line-height: 36px;

  // 总计
  .pagination-total {
    min-width: 124px;
    font-family: SimSun;
    text-align: right;
  }

  //每页条数
  .pagination-sizes {
    position: relative;
    margin-left: 9px;
    width: 123px;
    height: 36px;
    font-family: SimSun;

    select {
      width: 100%;
      height: 100%;
      border: 1px solid #e0e0e0;
      padding-left: 5px;
      border-radius: 3px;
      box-sizing: border-box;
      font-size: 12px;
      font-family: SimSun;
      font-weight: 400;
      color: #a1a1a1;
      outline: none;
      cursor: pointer;
    }

    div {
      position: absolute;
      top: 0;
      right: 0;
      width: 33px;
      height: 100%;
      padding-left: 10px;
      line-height: 54px;
      background: #fff;
      border: 1px solid #e0e0e0;
      border-left: none;
      border-radius: 3px;
      border-top-left-radius: 0;
      box-sizing: border-box;
      pointer-events: none;

      span {
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top-color: #9a9ba0;
      }
    }
  }

  //页数导航条
  .pagination-navbar {
    display: flex;
    width: auto;
    height: 36px;
    border: 1px solid #e0e0e0;
    border-radius: 3px;
    box-sizing: border-box;
    margin-left: 8px;
    cursor: pointer;
    user-select: none;

    .navbar-item {
      border-right: 1px solid #e0e0e0;
      padding: 0 14px;

      &:hover {
        color: #a1a1a1;
        background-color: #eee;
        border-color: #ddd;
      }
    }

    .num-page {
      display: flex;
      padding: 0;
      text-align: center;
      border-right: none;

      &:hover {
        color: #a1a1a1;
        background-color: #fff;
        border-color: #e0e0e0;
      }

      li {
        width: 36px;
        height: 100%;
        border-right: 1px solid #e0e0e0;
        font-size: 14px;
        font-family: Arial;
        font-weight: 400;
        color: #a1a1a1;

        &:hover {
          color: #a1a1a1;
          background-color: #eee;
          border-color: #ddd;
        }
      }

      .active {
        background: #bcbfcd;
        color: #fff;

        &:hover {
          background: #bcbfcd;
          color: #fff;
        }
      }
    }

    .last-page {
      border-right: none;
    }

    .disabled {
      pointer-events: none;
    }
  }
}
</style>